import { UploadComponent } from "./uploadImage"

type UploadComponentProps = {
  value?: string,
  onChange?: (value: string) => void,
  placeholder?: string,
}

export const UploadComponentAntdCompatibilityWrapper = ({
  value,
  onChange,
  placeholder = "Upload Banner Image",
}: UploadComponentProps) => {
  return <UploadComponent image={value ?? ""} setImage={(next: string) => onChange?.(next)} placeholder={placeholder} />
}
